import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import Button from './Button';

const WarningText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.xl};
`;

const DeleteAccountModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Account"
    >
      <WarningText>
        Warning: This action cannot be undone. Deleting your account will:
      </WarningText>
      <ul>
        <li>Permanently delete all your rooms and items</li>
        <li>Remove all your photos and receipts</li>
        <li>Cancel your premium subscription (if active)</li>
        <li>Delete your household sharing settings</li>
        <li>Remove all your user data</li>
      </ul>
      <p>Are you absolutely sure you want to delete your account?</p>
      
      <ButtonContainer>
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Deleting...' : 'Yes, Delete My Account'}
        </Button>
      </ButtonContainer>
    </Modal>
  );
};

export default DeleteAccountModal; 